export default __webpack_public_path__ + "static/media/correct.578d18bb.svg";